module.exports = __webpack_public_path__ + "img/md-film.8c95b411.svg";